<!-- Nội Dung Chính -->
<div class="container mt-4">
    <!-- Tiêu Đề với Biểu Tượng -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-tags mr-2"></i> Gợi Ý Mua Sắm
    </h1>
  
    <!-- Mô Tả Dưới Tiêu Đề -->
    <p class="lead mb-4">
      Xem và quản lý các gợi ý mua sắm cho sách và các phương tiện khác. Sử dụng các tab để khám phá tổng quan về các gợi ý, duyệt danh sách các gợi ý hoặc tham khảo hướng dẫn sử dụng để biết thêm chi tiết. Thêm gợi ý mới hoặc chỉnh sửa các gợi ý hiện có bằng các tùy chọn bên dưới.
    </p>
  
    <!-- Tab Điều Hướng -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#List">
          <i class="fas fa-list mr-2"></i> Danh Sách
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#UserManual">
          <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
        </a>
      </li>
    </ul>
  
    <!-- Nội Dung Tab -->
    <div class="tab-content">
      <!-- Nội Dung Tab Danh Sách -->
      <div id="List" class="tab-pane fade show active">
        <div class="container-fluid" style="background-color: white;">
          <!-- Nút Kích Hoạt Modal -->
          <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Thêm Gợi Ý Mua Sắm</button>
          <button
            href="#"
            role="button"
            class="btn btn-outline-warning btn-icon-split"
            (click)="loadPurchaseSuggestions()">
            <span class="icon text-warning">
              <i class="fas fa-redo"></i>
            </span>
            <span class="text">Tải Lại</span>
          </button>
          <!-- Bảng Gợi Ý Mua Sắm -->
          <div class="card mb-4">
            <div class="card-body">
              <div class="table-responsive">
                <div *ngIf="loadingIndicator; else loaded">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Đang tải...</span>
                    </div>
                  </div>
                </div>
                <ng-template #loaded>
                  <ngx-datatable
                  class="bootstrap"
                  [rows]="purchaseSuggestions"
                  [columnMode]="'force'"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                  [limit]="10"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)">
                  <!-- Tiêu Đề -->
                  <ngx-datatable-column name="Tiêu Đề" [prop]="'title'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.title }}
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- ISBN -->
                  <ngx-datatable-column name="ISBN" [prop]="'ISBN'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span style="color: red;">{{ row.isbnIssnOtherStandardNumber }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Nơi Xuất Bản -->
                  <ngx-datatable-column name="Nơi Xuất Bản" [prop]="'publicationPlace'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.publicationPlace }}
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Lý Do Gợi Ý -->
                  <ngx-datatable-column name="Lý Do Gợi Ý" [prop]="'reasonForSuggestion'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.reasonForSuggestion }}
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Số Bản Sao -->
                  <ngx-datatable-column name="Số Bản Sao" [prop]="'copies'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.copies }}
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Giá -->
                  <ngx-datatable-column name="Giá" [prop]="'price'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.price | currency }}
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Tổng Cộng -->
                  <ngx-datatable-column name="Tổng Cộng" [prop]="'total'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.total | currency }}
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Trạng Thái -->
                  <ngx-datatable-column name="Trạng Thái" [prop]="'status'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span style="color: green;">{{ row.status}}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <!-- Hành Động -->
                  <ngx-datatable-column name="Hành Động">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <button type="button" class="btn btn-sm btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Hành Động
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item"  (click)="openEditDialog(row)">
                            <i class="fas fa-edit"></i> Chỉnh Sửa
                        </a>
                        <a class="dropdown-item"  (click)="deletePurchaseSuggestion(row.id)">
                            <i class="fas fa-trash"></i> Xóa
                        </a>
                        <a class="dropdown-item" (click)="approve(row)">
                            <i class="fas fa-thumbs-up"></i> Phê Duyệt
                        </a>
                        <a class="dropdown-item" (click)="reject(row)">
                            <i class="fas fa-thumbs-down"></i> Từ Chối
                        </a>
                    </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
                </ng-template> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Nội Dung Tab Hướng Dẫn Sử Dụng -->
      <div id="UserManual" class="tab-pane fade" style="background-color: white;" >
        <div>
           <div  [innerHTML]="markdownContent"></div>
       </div>
      </div>
    </div>
  </div>
